"use strict";
/**
 * API Request/Response Types
 *
 * Types for data sent between frontend and backend
 * Derived from database types with appropriate transformations
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./user"), exports);
__exportStar(require("./pattern"), exports);
__exportStar(require("./review"), exports);
__exportStar(require("./comment"), exports);
__exportStar(require("./social"), exports);
__exportStar(require("./notification"), exports);
__exportStar(require("./search"), exports);
__exportStar(require("./moderation"), exports);
__exportStar(require("./user-moderation-records"), exports);
__exportStar(require("./craft-room"), exports);
__exportStar(require("./craft-projects"), exports);
__exportStar(require("./collection"), exports);
__exportStar(require("./appeals"), exports);
__exportStar(require("./feedback"), exports);
__exportStar(require("./image-upload-responses"), exports);
__exportStar(require("./image-processing"), exports);
__exportStar(require("./visibility"), exports);
__exportStar(require("./material-admin"), exports);
__exportStar(require("./analytics"), exports);
__exportStar(require("./pdf"), exports);
__exportStar(require("./draft-review"), exports);
__exportStar(require("./permissions"), exports); // DerivedPermissionFlags, BanSlotView, GetBanStateResponse, SetBanSlotInput, SetBanStateRequest, SetBanStateResponse
